<div id="member_signup" class="login_me" role="dialog">
    <!-- <div class="modal-dialog"> -->
      <!-- Modal content-->
      <div class="modal-content">
        <button type="button" class="close close_modal"  style="outline: none;" data-dismiss="modal" (click)="dismiss()"><span aria-hidden="true">×</span></button>
        <div class="modal-header">
          <h4 class="modal-title">Member SignUp!</h4>
          <p>Enter your following fields to sign Up</p>
        </div>
        <div class="modal-body">
          <form class=""  [formGroup]="memberSignUp" (ngSubmit)="memberSinup()">
          <div class="row">
             <div class="col-md-9">
              
                  <div class="row">
                  <div class="col-md-12">
                <div class="form-group">
                  <input type="text" formControlName="usersName" class="form-control" id="email" placeholder="Name">
                  <ng-container *ngIf="submitted && memUp.usersName.errors">
                    <p class="error-message" *ngIf=" memUp.usersName.errors.required">
                        Name is required!
                    </p>
                </ng-container>
                </div>
                </div>
                <div class="col-md-12">
                <div class="form-group">
                <ngx-intl-tel-input
                [preferredCountries]="[CountryISO.Singapore, CountryISO.India]"
                [enableAutoCountrySelect]="false"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectFirstCountry]="false"
                [maxLength]="10"
                [selectedCountryISO]="CountryISO.Singapore"
                [phoneValidation]="true"
                [customPlaceholder]="customPlaceholderValue"
                name="phone"
                [(ngModel)]="phone" [ngModelOptions]="{standalone: true}"
                ></ngx-intl-tel-input>
                </div>
                <div class="form-group">
                  <input type="text" formControlName="email" class="form-control" id="email" placeholder="Email"> 
                  <ng-container *ngIf="submitted && memUp.email.errors">
                    <p class="error-message" *ngIf=" memUp.email.errors.required">
                      Email is required!
                  </p>
                    <p class="error-message" *ngIf=" memUp.email.errors.email">
                      Please Enter a valid email!
                  </p>
                </ng-container>
                </div>
                </div>
                <div class="row ml-1">
                  <div class="col-md-4">
                    <div class="form-group">
                    <input type="text" formControlName="position" class="form-control" id="email" placeholder="Postion">
                  </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                    <input type="text" formControlName="noYear" class="form-control" id="email" placeholder="No.of Years">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                    <input type="text" formControlName="lastComp" class="form-control" id="email" placeholder="Last Company">
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                   <button class="sign_in" [disabled]="clicked" [ngClass]="{'disabled':clicked == true}" style="outline: none;"> Sign Up </button>
               </div>
               <div class="col-md-12 text center">
                <a (click)="dismiss()" style="background:transparent;height:34px">
                  <img loading="lazy" style="height: 38px; width: 38px;" src="../../../../assets/images/backcu.png"></a>
               </div>
              <!--   <div class="col-md-12">
                    <div class="checkbox">
                      <label> New MEmber?</label>
                    </div>
                </div> -->
               </div>
              </div>
              <div class="col-md-3">
                <div class="">
                  <h4 class="mb-3"> Upload File </h4>
                    <div class="upld_form imgs_show">
                      <ul *ngIf="isFileUploaded">
                        <li *ngFor='let url of urls'><img loading="lazy" [src]="url" class="selected"></li> 
                      </ul>  
                      <img loading="lazy" *ngIf="!isFileUploaded" [src]="recieptImage" style="height: 150px; border-radius: 20px;">
                       <!-- <input type="file" nbInput fullWidth #file accept=".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf" (change)="onFileSelected(file.files)">  -->
                       <input type="file" nbInput fullWidth #file accept=".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf" (change)="onFileSelected($event)"> 
                    </div>
                </div>
              </div>
            </div>
              </form>
        </div>
      </div>
    <!-- </div> -->
  </div>



